<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">After Words</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#point-of-origin">Point of Origin</a></li>
<li id="toc-li-5"><span href="#/text/ch005#during-the-pandemic" title="Link target outside of Sample">During the Pandemic</span></li>
<li id="toc-li-6"><span href="#/text/ch006#fools-gold" title="Link target outside of Sample">Fool’s Gold</span></li>
<li id="toc-li-7"><span href="#/text/ch007#to-the-nth-degree" title="Link target outside of Sample">To the Nth Degree</span></li>
<li id="toc-li-8"><span href="#/text/ch008#a-sleight-of-hand" title="Link target outside of Sample">A Sleight of Hand</span></li>
<li id="toc-li-9"><span href="#/text/ch009#of-sound-mind" title="Link target outside of Sample">Of Sound Mind</span></li>
<li id="toc-li-10"><span href="#/text/ch010#clear-as-a-bell" title="Link target outside of Sample">Clear as a Bell</span></li>
<li id="toc-li-11"><span href="#/text/ch011#après-coup" title="Link target outside of Sample">Après Coup</span></li>
<li id="toc-li-12"><span href="#/text/ch012#epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li id="toc-li-13"><span href="#/text/ch013#acknowledgment" title="Link target outside of Sample">Acknowledgment</span></li>
<li id="toc-li-14"><span href="#/text/ch014#advanced-praise" title="Link target outside of Sample">Advanced Praise</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?208670cf